const ROUTES_NAME = {
    LOGIN: '/',
    INSTRUCTION: '/instructions',
    DASHBOARD: '/myexam',
    REGISTRATION: '/faceregistration',
    FACE_VERIFICATION: '/face-verification',
    TEST: '/test',
    THANK_YOU:'/thankyou',
    EXAM_SCORE:'/exam-score',
    AUTH_ERROR:'/auth-error',
    SUBJECT_SELECTION:'/subject-selection',
    CENTER_FEEDBACK:'/center-feedback',
  };
  
  export default ROUTES_NAME;
  